import { Form, Select } from 'antd';
import { useGetAllUsers } from 'api/users/use-get-all-users.ts';
import type { IUserFormSelectProps } from './types';

export const UserFormSelect = (props: IUserFormSelectProps) => {
  const {
    name,
    handleUserChange,
    placeholder,
    label,
    required = false,
    disabled = false,
    allowClear = false,
    className,
  } = props;

  const { data: users, isLoading: isLoadingUsers } = useGetAllUsers();

  return (
    <Form.Item label={label} name={name} className={className} required={required}>
      <Select
        optionFilterProp='label'
        placeholder={placeholder}
        loading={isLoadingUsers}
        filterOption={true}
        notFoundContent={null}
        disabled={disabled}
        options={users?.map((user) => ({
          value: user.id,
          label: user.name,
        }))}
        allowClear={allowClear}
        showSearch
        labelInValue
        onChange={handleUserChange}
      />
    </Form.Item>
  );
};
